export default {
  id: 'operations',
  title: 'Service status, usage and apportionments (admin)',
  note: 'The four read-only audit screens: service status changes, usage events, usage logs and apportionments. Status and event codes themselves come from the API and are not edited here.',
  texts: {
    // ---- Service status changes -------------------------------------------
    'serviceStatus.crumb': 'Service status changes',
    'serviceStatus.title': 'Service status changes',
    'serviceStatus.sub': 'Booking lifecycle events (BOOK → CONFIRM → CANCEL / REFUND / COMPLETE)',
    'serviceStatus.exportCsv': 'Export CSV',
    'serviceStatus.tab.all': 'All',
    'serviceStatus.search.placeholder': 'Search transaction, agreement, RICS, order ID…',
    'serviceStatus.count': '{shown} of {total}',
    'serviceStatus.loading': 'Loading…',
    'serviceStatus.empty': 'No status changes match the filter.',
    'serviceStatus.loadFailed': 'Failed to load status changes',
    'serviceStatus.column.timestamp': 'Timestamp',
    'serviceStatus.column.transaction': 'Transaction',
    'serviceStatus.column.newStatus': 'New status',
    'serviceStatus.column.sellerSupplier': 'Seller → Supplier',
    'serviceStatus.column.agreement': 'Agreement',
    'serviceStatus.column.source': 'Source',
    'serviceStatus.sellerSupplierSeparator': '→',
    'serviceStatus.csv.timestamp': 'Timestamp',
    'serviceStatus.csv.transaction': 'Transaction',
    'serviceStatus.csv.agreement': 'Agreement',
    'serviceStatus.csv.newStatus': 'New status',
    'serviceStatus.csv.seller': 'Seller',
    'serviceStatus.csv.sellerRics': 'Seller RICS',
    'serviceStatus.csv.supplier': 'Supplier',
    'serviceStatus.csv.supplierRics': 'Supplier RICS',
    'serviceStatus.csv.sellerOrderId': 'Seller order ID',
    'serviceStatus.csv.supplierOrderId': 'Supplier order ID',

    // ---- Usage events -----------------------------------------------------
    'usageEvents.crumb': 'Usage events',
    'usageEvents.title': 'Usage events',
    'usageEvents.sub': 'eTCD-style check-in / check-out events submitted by carriers — read-only audit view',
    'usageEvents.exportCsv': 'Export CSV',
    'usageEvents.tab.all': 'All',
    'usageEvents.search.placeholder': 'Search account, location, agreement, tx ID, RICS…',
    'usageEvents.count': '{shown} of {total}',
    'usageEvents.loading': 'Loading…',
    'usageEvents.empty': 'No usage events match the filter.',
    'usageEvents.loadFailed': 'Failed to load usage events',
    'usageEvents.column.timestamp': 'Timestamp',
    'usageEvents.column.account': 'Account',
    'usageEvents.column.event': 'Event',
    'usageEvents.column.location': 'Location',
    'usageEvents.column.supplier': 'Supplier',
    'usageEvents.column.agreement': 'Agreement',
    'usageEvents.column.transaction': 'Transaction',
    'usageEvents.csv.timestamp': 'Timestamp',
    'usageEvents.csv.account': 'Account',
    'usageEvents.csv.event': 'Event',
    'usageEvents.csv.location': 'Location',
    'usageEvents.csv.supplier': 'Supplier',
    'usageEvents.csv.supplierRics': 'Supplier RICS',
    'usageEvents.csv.agreement': 'Agreement',
    'usageEvents.csv.transaction': 'Transaction',

    // ---- Usage logs -------------------------------------------------------
    'usageLogs.crumb': 'Usage logs',
    'usageLogs.title': 'Usage logs',
    'usageLogs.sub': 'Aggregated per-account usage summaries submitted by carriers — read-only',
    'usageLogs.exportCsv': 'Export CSV',
    'usageLogs.search.placeholder': 'Search transaction, agreement, account, RICS…',
    'usageLogs.count': '{shown} of {total}',
    'usageLogs.loading': 'Loading…',
    'usageLogs.empty': 'No usage logs match the filter.',
    'usageLogs.loadFailed': 'Failed to load usage logs',
    'usageLogs.column.transaction': 'Transaction',
    'usageLogs.column.agreement': 'Agreement',
    'usageLogs.column.account': 'Account',
    'usageLogs.column.accountProvider': 'Account provider',
    'usageLogs.column.periodStart': 'Period start',
    'usageLogs.column.periodEnd': 'Period end',
    'usageLogs.column.created': 'Created',
    'usageLogs.csv.transaction': 'Transaction',
    'usageLogs.csv.agreement': 'Agreement',
    'usageLogs.csv.account': 'Account',
    'usageLogs.csv.accountProvider': 'Account provider',
    'usageLogs.csv.apRics': 'AP RICS',
    'usageLogs.csv.periodStart': 'Period start',
    'usageLogs.csv.periodEnd': 'Period end',
    'usageLogs.csv.created': 'Created',

    // ---- Apportionments ---------------------------------------------------
    'apportionments.crumb': 'Apportionments',
    'apportionments.title': 'Apportionments',
    'apportionments.sub': 'Per-account revenue allocations submitted by carriers — used by the settlement engine',
    'apportionments.exportCsv': 'Export CSV',
    'apportionments.search.placeholder': 'Search transaction, agreement, account, RICS…',
    'apportionments.count': '{shown} of {total}',
    'apportionments.loading': 'Loading…',
    'apportionments.empty': 'No apportionments match the filter.',
    'apportionments.loadFailed': 'Failed to load apportionments',
    'apportionments.column.transaction': 'Transaction',
    'apportionments.column.account': 'Account',
    'apportionments.column.accountProvider': 'Account provider',
    'apportionments.column.mobilityProvider': 'Mobility provider',
    'apportionments.column.amount': 'Amount',
    'apportionments.column.period': 'Period',
    // Joins the two period dates; the surrounding spaces are deliberate.
    'apportionments.periodSeparator': ' → ',
    'apportionments.csv.transaction': 'Transaction',
    'apportionments.csv.agreement': 'Agreement',
    'apportionments.csv.account': 'Account',
    'apportionments.csv.accountProvider': 'Account provider',
    'apportionments.csv.apRics': 'AP RICS',
    'apportionments.csv.msp': 'MSP',
    'apportionments.csv.mspRics': 'MSP RICS',
    'apportionments.csv.amount': 'Amount',
    'apportionments.csv.periodStart': 'Period start',
    'apportionments.csv.periodEnd': 'Period end',
  },
}
